import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingFounder.css";

export default function CoFounderLandingPage() {
  const screenshots = [
    "/screen1.png",
    "/screen2.png",
    "/screen3.png",
    "/screen4.png",
    "/screen5.png",
  ];

  const [currentScreen, setCurrentScreen] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreen((prev) => (prev + 1) % screenshots.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  const goToRegister = () => {
    navigate("/register");
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });

    setMenuOpen(false);
  };

  return (
    <div className="landing cofounder-landing">

      {/* =========================
          NAVBAR
      ========================== */}
      <nav className={`navbar ${menuOpen ? "menu-is-open" : ""}`}>

        <div
          className="logo"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <img
            src="/logo-side-by-side.png"
            alt="Nessefy Logo"
            className="logo-img"
          />
        </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>
          <a href="#why" onClick={() => setMenuOpen(false)}>
            Why Nessefy
          </a>

          <a href="#how" onClick={() => setMenuOpen(false)}>
            How It Works
          </a>

          <a href="#community" onClick={() => setMenuOpen(false)}>
            Community
          </a>
        </div>

        <div className="nav-actions">

          <button
            className="nav-login"
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>

          <button
            className="nav-btn"
            onClick={goToRegister}
          >
            Join Free
          </button>

          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>
      </nav>


      {/* =========================
          HERO
      ========================== */}
      <section className="hero cofounder-hero">

        <div className="hero-blob blob-1"></div>
        <div className="hero-blob blob-2"></div>
        <div className="hero-blob blob-3"></div>

        <div className="hero-content">

          <p className="hero-badge">
            🤝 BUILT FOR PEOPLE WHO WANT TO BUILD
          </p>

          <h1>
            Your Co-Founder
            <br />
            Is Out There.
            <br />

            <span className="highlight">
              You Just Haven't
              <span> Met Yet.</span>
            </span>
          </h1>

          <p>
            Find ambitious entrepreneurs, builders, and business minds
            who are looking for someone to build something meaningful with.
          </p>

          <div className="hero-buttons">

            <button
              className="primary-btn"
              onClick={goToRegister}
            >
              🤝 Find My Co-Founder
              <span className="button-arrow">→</span>
            </button>

            <button
              className="secondary-btn"
              onClick={() => scrollTo("how")}
            >
              See How It Works
            </button>

          </div>

          <div className="free-points">

            <span>
              <b>✓</b> 100% free to join
            </span>

            <span>
              <b>✓</b> No credit card
            </span>

            <span>
              <b>✓</b> Built for builders
            </span>

          </div>

        </div>


        {/* HERO VISUAL */}
        <div className="hero-card cofounder-hero-card">

          <div className="floating-mini-card mini-card-1">
            <h4>🤝 Founder Match</h4>
            <p>Find people who complement you</p>
          </div>

          <div className="post-card cofounder-post-card">

            <div className="cofounder-network">

              <div className="network-circle network-one">
                👨🏻‍💻
              </div>

              <div className="network-circle network-two">
                👩🏻‍💼
              </div>

              <div className="network-circle network-three">
                👨🏽‍🚀
              </div>

              <div className="network-line line-one"></div>
              <div className="network-line line-two"></div>
              <div className="network-line line-three"></div>

              <div className="network-center">
                <img
                  src="/n-logo.png"
                  alt="Nessefy"
                />
              </div>

            </div>

            <div className="post-card-copy">
              <h3>Find Your People.</h3>
              <p>
                Ideas become bigger when the right people build them together.
              </p>
            </div>

          </div>

        </div>

      </section>


      {/* =========================
          FREE STRIP
      ========================== */}
      <section className="free-strip">

        <div className="free-strip-icon">
          ✓
        </div>

        <div>
          <strong>Joining Nessefy is completely free.</strong>
          <span>
            Create your profile, discover people and start connecting.
            No subscription. No joining fee.
          </span>
        </div>

        <button onClick={goToRegister}>
          Join Free →
        </button>

      </section>


      {/* =========================
          SHOWCASE
      ========================== */}
      <section className="showcase">

        <div className="showcase-content">

          <span className="showcase-tag">
            FIND YOUR PEOPLE
          </span>

          <h2>
            Stop searching
            <br />
            everywhere.
            <br />
            <span className="showcase-highlight">
              Start searching smarter.
            </span>
          </h2>

          <p>
            Nessefy brings ambitious people into one ecosystem.
            Discover founders, professionals, freelancers, investors
            and builders who could become the missing piece in your journey.
          </p>

          <div className="app-download-buttons">

  <a
    href="https://play.google.com/store/apps/details?id=com.niteshagarwal8290.nessefymobile"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./Google-Play-Icon.png"
      alt="Get it on Google Play"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>GET IT ON</small>
      <strong>Google Play</strong>
    </span>
  </a>


  <a
    href="YOUR_APP_STORE_LINK"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="/App-Store.png"
      alt="Download on the App Store"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>DOWNLOAD ON THE</small>
      <strong>App Store</strong>
    </span>
  </a>

</div>

          <div className="showcase-benefits">

            <div>
              <span>01</span>
              <strong>Discover</strong>
              <p>Find people with complementary skills and ambitions.</p>
            </div>

            <div>
              <span>02</span>
              <strong>Connect</strong>
              <p>Start conversations without the awkward cold search.</p>
            </div>

            <div>
              <span>03</span>
              <strong>Build</strong>
              <p>Turn the right connection into something real.</p>
            </div>

          </div>

        </div>


        <div className="phone-showcase">

          <div className="floating-ui ui-top-left">
            🤝 Co-Founder Match
          </div>

          <div className="floating-ui ui-top-right">
            🚀 Build Together
          </div>

          <div className="floating-ui ui-bottom-left">
            💡 Complementary Skills
          </div>

          <div className="floating-ui ui-bottom-right">
            ✨ Free to Join
          </div>

          <div className="phone-frame">

            <div className="phone-notch"></div>

            <div className="phone-screen">

              <img
                key={currentScreen}
                src={screenshots[currentScreen]}
                alt="Nessefy App"
                className="phone-screenshot"
              />

            </div>

          </div>

        </div>

      </section>


      {/* =========================
          WHY SECTION
      ========================== */}
      <section
        id="why"
        className="features"
      >

        <div className="features-header">

          <span className="features-tag">
            WHY FIND YOUR CO-FOUNDER ON NESSEFY?
          </span>

          <h2>
            The right co-founder
            <br />
            can change everything.
          </h2>

          <p>
            Finding a co-founder shouldn't mean posting everywhere,
            sending hundreds of messages, or hoping someone happens
            to find you. Nessefy is designed to make that discovery easier.
          </p>

        </div>


        <div className="journey-container">

          <div className="journey-card">

            <div className="journey-step">
              01
            </div>

            <div className="journey-icon">
              🔎
            </div>

            <h3>
              Discover
            </h3>

            <p>
              Explore entrepreneurs, founders and professionals
              who are open to building something new.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card featured-journey">

            <div className="journey-step">
              02
            </div>

            <div className="journey-icon">
              🤝
            </div>

            <h3>
              Connect
            </h3>

            <p>
              Find people whose skills, interests and ambitions
              complement your own.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card">

            <div className="journey-step">
              03
            </div>

            <div className="journey-icon">
              🚀
            </div>

            <h3>
              Build
            </h3>

            <p>
              Start a conversation, explore the idea and discover
              what you could create together.
            </p>

          </div>

        </div>


        <div className="features-stats">

          <div>
            <h4>FREE</h4>
            <p>Join Nessefy</p>
          </div>

          <div>
            <h4>AI</h4>
            <p>Smarter connections</p>
          </div>

          <div>
            <h4>1</h4>
            <p>Entrepreneur ecosystem</p>
          </div>

        </div>

      </section>


      {/* =========================
          HOW IT WORKS
      ========================== */}
      <section
        id="how"
        className="about"
      >

        <div className="about-content">

          <span className="about-tag">
            HOW IT WORKS
          </span>

          <h2>
            From
            <br />
            “I need a co-founder”
            <br />
            to
            <span className="how-highlight">
              “Let's build.”
            </span>
          </h2>

          <p>
            You don't need to know exactly who you're looking for.
            Start with your profile, tell people what you're building
            and let Nessefy help you discover the possibilities.
          </p>


          <div className="about-points">

            <div>
              <h4>
                01 — Create your profile
              </h4>

              <p>
                Tell people who you are, what you're building,
                your skills and what kind of person you're looking for.
              </p>
            </div>


            <div>
              <h4>
                02 — Discover your people
              </h4>

              <p>
                Explore entrepreneurs and professionals who could
                be the right fit for your journey.
              </p>
            </div>


            <div>
              <h4>
                03 — Start building
              </h4>

              <p>
                Connect, have a conversation and see where the
                right connection takes you.
              </p>
            </div>

          </div>

        </div>


        <div className="about-visual">

          <div className="orbit-card about-card-1">
            Founder
          </div>

          <div className="orbit-card about-card-2">
            Developer
          </div>

          <div className="orbit-card about-card-3">
            Designer
          </div>

          <div className="orbit-card about-card-4">
            Business
          </div>

          <div className="orbit-card about-card-5">
            Marketer
          </div>


          <div className="about-center-card cofounder-center-card">

            <img
              src="/n-logo.png"
              alt="Nessefy Logo"
            />

            <h3>
              Find Your Fit
            </h3>

            <p>
              Skills • Ideas • Ambition
            </p>

          </div>

        </div>

      </section>


      {/* =========================
          COMMUNITY
      ========================== */}
      <section
        id="community"
        className="community-section"
      >

        <div className="community-content">

          <span className="community-tag">
            A COMMUNITY OF BUILDERS
          </span>

          <h2>
            You are not the only one
            <br />
            looking for someone to build with.
          </h2>

          <p>
            Nessefy brings together entrepreneurs, founders,
            freelancers, investors and professionals who want
            to create, collaborate and grow.
          </p>


          <div className="community-people">

            <div className="community-avatar">
              👨🏻‍💻
            </div>

            <div className="community-avatar">
              👩🏻‍💻
            </div>

            <div className="community-avatar">
              👨🏽‍💼
            </div>

            <div className="community-avatar">
              👩🏽‍🚀
            </div>

            <div className="community-avatar">
              👨🏻‍🎨
            </div>

            <div className="community-count">
              +
            </div>

          </div>


          <div className="community-labels">

            <span>Entrepreneurs</span>
            <span>Founders</span>
            <span>Builders</span>
            <span>Freelancers</span>
            <span>Investors</span>

          </div>

        </div>

      </section>


      {/* =========================
          FINAL CTA
      ========================== */}
      <section className="contact-section final-cofounder-cta">

        <div className="contact-content">

          <span className="contact-tag">
            YOUR NEXT CHAPTER
          </span>

          <h2>
            Stop looking for
            <br />
            a co-founder
            <br />
            everywhere.
          </h2>

          <h3>
            Start looking on
            <span>Nessefy.</span>
          </h3>

          <p>
            Join for free. Create your profile.
            Start discovering people who could help
            you build your next big thing.
          </p>

          <button
            className="primary-btn final-cta-button"
            onClick={goToRegister}
          >
            🤝 Find My Co-Founder
            <span>— It's Free</span>
          </button>

          <div className="final-free-line">
            ✓ Free to join
            <span>•</span>
            ✓ No credit card
            <span>•</span>
            ✓ Takes less than 2 minutes
          </div>

        </div>


        <div className="contact-card final-free-card">

          <div className="free-card-icon">
            ✓
          </div>

          <span>
            NO CATCH.
          </span>

          <h3>
            Nessefy is
            <br />
            <strong>100% FREE</strong>
            <br />
            to join.
          </h3>

          <p>
            Create your profile and start
            meeting people who want to build.
          </p>

          <button
            onClick={goToRegister}
            className="free-card-button"
          >
            Create My Free Profile →
          </button>

        </div>

      </section>


      {/* =========================
          FOOTER
      ========================== */}
      <footer className="footer">

        <p>
          © 2026 Nessefy. All rights reserved.
        </p>

        <div className="footer-links">

          <span
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </span>

          <span
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms & Conditions
          </span>

        </div>

      </footer>

    </div>
  );
}